// import-field-normalizer.ts
export function normalizeImportFields(entity: string, res: any): { key: string; label: string }[] {
    let fields: any[] = [];
    let mappedFields: any[] = [];
    switch (entity) {
        case 'Timesheets':
            fields = res.data?.[0]?.fields ?? [];
            mappedFields = [
                { key: 'contractor_email', label: 'Contractor Email' },
                { key: 'job', label: 'Job Name' },
                { key: 'start_date', label: 'Start Date' },
                { key: 'end_date', label: 'End Date' },
                ...fields.map((f: any) => ({
                    key: f.uuid,
                    label: f.label,
                })),
            ];
            break;
        case 'Client':
            fields = res.data?.fields ?? [];
            break;
        case 'Contractor':
            fields = res.fields ?? [];
            break;
        case 'Job':
            fields = res.meta?.fields ?? [];
            break;
        default:
            fields = [];
    }

    return mappedFields;
}
